import React, { createContext, memo, PropsWithChildren, useMemo } from 'react';

type TabsContextProps = {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
};

export const TabsContext = createContext<TabsContextProps>({
  activeTab: 0,
  setActiveTab: () => {},
});

type Props = PropsWithChildren & {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
};

export const Tabs = memo(({ activeTab, setActiveTab, children }: Props) => {
  const value = useMemo(() => ({
    activeTab,
    setActiveTab,
  }), [activeTab, setActiveTab]);

  return (
    <TabsContext.Provider value={value}>{children}</TabsContext.Provider>
  );
});
